import { memo, useCallback, useEffect } from "react";
import Image from "../../../../Elements/Image/Image";
import setPlanetIconStyles from "../../helpers/setPlanetIconStyles";

import styles from "./styles.module.scss";

const SPEED = 0.5;
const defaultOffsets = [
  { name: "securityIcon", offset: 0 },
  { name: "userIcon", offset: 33 },
  { name: "cloudIcon", offset: 66 },
  { name: "mailIcon", offset: 15 },
  { name: "storageIcon", offset: 48 },
  { name: "galleryIcon", offset: 81 },
];

const SolarSystemLogo = memo(() => {
  const parallax = useCallback((e: MouseEvent) => {
    const offset = (e.clientX / window.innerWidth) * 100 * SPEED;

    defaultOffsets.forEach((defaultOffsets) => {
      setPlanetIconStyles(
        document.getElementById(defaultOffsets.name),
        offset,
        defaultOffsets.offset
      );
    });
  }, []);

  useEffect(() => {
    document.addEventListener("mousemove", parallax);
    return () => {
      document.removeEventListener("mousemove", parallax);
    };
  }, []);

  return (
    <div className={styles.solarSystemLogoWrapper}>
      <Image name="features/logo" ext="svg" className={styles.logo} />
      <Image
        name="features/ellipseforwardup"
        ext="svg"
        className={styles.ellipseFwdUp}
      />
      <Image
        name="features/ellipseforwarddown"
        ext="svg"
        className={styles.ellipseFwdDown}
      />
      <Image
        name="features/ellipsebackwardup"
        ext="svg"
        className={styles.ellipseBwdUp}
      />
      <Image
        name="features/ellipsebackwarddown"
        ext="svg"
        className={styles.ellipseBwdDown}
      />
      <Image
        name="features/security"
        ext="svg"
        className={styles.securityIcon}
        id="securityIcon"
      />
      <Image
        name="features/user"
        ext="svg"
        className={styles.userIcon}
        id="userIcon"
      />
      <Image
        name="features/cloud"
        ext="svg"
        className={styles.cloudIcon}
        id="cloudIcon"
      />
      <Image
        name="features/mail"
        ext="svg"
        className={styles.mailIcon}
        id="mailIcon"
      />
      <Image
        name="features/storage"
        ext="svg"
        className={styles.storageIcon}
        id="storageIcon"
      />
      <Image
        name="features/gallery"
        ext="svg"
        className={styles.galleryIcon}
        id="galleryIcon"
      />

      <Image
        name="features/shinydot"
        ext="svg"
        className={styles.shinyDotIcon1}
      />
      <Image
        name="features/shinydot"
        ext="svg"
        className={styles.shinyDotIcon2}
      />
      <Image
        name="features/shinydot"
        ext="svg"
        className={styles.shinyDotIcon3}
      />
      <Image
        name="features/shinydot"
        ext="svg"
        className={styles.shinyDotIcon4}
      />
    </div>
  );
});

export default SolarSystemLogo;
